import { render, staticRenderFns } from "./DrugSusceptibility.vue?vue&type=template&id=37e3a6d5&scoped=true"
import script from "./DrugSusceptibility.vue?vue&type=script&lang=js"
export * from "./DrugSusceptibility.vue?vue&type=script&lang=js"
import style0 from "./DrugSusceptibility.vue?vue&type=style&index=0&id=37e3a6d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e3a6d5",
  null
  
)

export default component.exports